import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box } from "@curves/ui-base";
import { CycleOrderList, CycleOrderMonthStatisticsBox } from "@icoach/members/components";
import useMemberCyclePurchaseApi from "@apis/useMemberCyclePurchaseApi";
import { useMemberDetailContext } from "@icoach/memberDetail/MemberDetailContext";
import CyclePurchaseDialogBox from "@icoach/healthyCyclePurchase/dialog/CyclePurchaseDialogBox";

const MemberDetailCycleOrderContentOverview = props => {
	const { memberID } = props;
	const { setRefresh } = useMemberDetailContext();
	const { getMemberCycleOrderApi } = useMemberCyclePurchaseApi();
	const [orders, setOrders] = useState([]);

	const dialogRef = useRef(null);

	const doMemberCycleOrderApi = useCallback(
		async () => {
			let res = await getMemberCycleOrderApi(memberID);
			if (res) {
				setOrders(res);
			}
		},
		// eslint-disable-next-line
		[memberID],
	);

	useEffect(() => {
		if (memberID) {
			setRefresh(doMemberCycleOrderApi);
			doMemberCycleOrderApi();
		}
		// eslint-disable-next-line
	}, [memberID]);

	return (
		<Box>
			<CycleOrderMonthStatisticsBox className={"mb-4"} memberID={memberID} />
			<CycleOrderList orders={orders} dialogRef={dialogRef} refresh={doMemberCycleOrderApi} />
			<CyclePurchaseDialogBox ref={dialogRef} />
		</Box>
	);
};

export default MemberDetailCycleOrderContentOverview;
